const requestCheck = document.querySelector('#enable_invoice')
const selectCheck = document.querySelector('.select-invoice-type')

requestCheck.addEventListener('click', enableSelectChoice)
selectCheck.addEventListener('change', enableForm)

function enableSelectChoice(){
    const conditionalPart = document.querySelector('.request-invoice__conditional');

    if( requestCheck.checked == true ){
        conditionalPart.style.display = 'grid'
        conditionalPart.querySelector('select').disabled = false
    }else{
        conditionalPart.style.display = 'none'
        conditionalPart.querySelector('select').disabled = true
    }
}

function enableForm(e) {
    const contForm = document.querySelectorAll('.request-invoice__form')
    let currentValue = selectCheck.value.toLowerCase()

    contForm.forEach(tab => {
        const inputForm = tab.querySelectorAll('input')
        if(tab.classList.contains('invoice-' + currentValue)){
            tab.style.display = 'flex'
            inputForm.forEach(item => item.disabled = false)
        }else{
            tab.style.display = 'none'
            inputForm.forEach(item => item.disabled = true)
        }
    });
}